import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { BaseParamsService } from '../base-params.service';

@Injectable()
export class BaseParamsResolverGuard implements CanActivate, CanActivateChild {
  constructor(private baseParamsService: BaseParamsService) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    this.baseParamsService.parseParams(route);
    return true;
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot): boolean {
    return this.canActivate(childRoute);
  }
}
